import { render } from "./DadosGerais.vue?vue&type=template&id=f1027c12"
import script from "./DadosGerais.vue?vue&type=script&lang=js"
export * from "./DadosGerais.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__